<template>
  <div class="stationGroup tableStyle">
    <el-row>
      <el-col :span="24">
        <query
          :formData="formData"
          :formList="formList"
          @reset="resetQuery"
          @query="query"
          @clear="query"
        ></query>
      </el-col>
    </el-row>

    <div class="tableArea">
      <el-table :data="tableData" class="table-border" height="100%">
        <el-table-column type="index" label="序号" align="center"></el-table-column>
        <el-table-column prop="name" label="桩群名称" width="300"></el-table-column>
        <el-table-column prop="legal_tel" label="桩群地址">
          <template slot-scope="scope">
              {{stationAddress(scope.row) || '-'}}
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="创建时间" width="200"></el-table-column>
        <el-table-column prop="status" label="状态" align="center" width="120">
          <template slot-scope="scope">
              <span v-if="scope.row.status === 0">申请中</span>
              <span v-else-if="scope.row.status === 1">服务中</span>
              <span v-else-if="scope.row.status === 2">已停用</span>
          </template>
        </el-table-column>
        <el-table-column prop="tel" label="客服电话" align="center" width="120"></el-table-column>
        <el-table-column label="充电桩数量" align="center" width="120">
          <template slot-scope="scope">
            {{scope.row.pile.length}}
          </template>
        </el-table-column>
        <el-table-column label="备注" align="center" width="220">
          <template slot-scope="scope">
              {{scope.row.remark || '-'}}
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-row class="pageFoot">
      <el-col :span="12">
        <div class="statistical">
          统计：桩群数量（{{total}}）个 &nbsp;&nbsp;&nbsp;&nbsp;充电桩数量（{{stationTotal}}）个
        </div>
      </el-col>
      <el-col :span="12">
        <el-pagination
          layout="total, prev, pager, next, sizes"
          background
          :page-size="size"
          :total="total"
          :page-sizes="[20,50,100,200,500,1000]"
          @size-change="sizeChange"
          @current-change="changePage">
        </el-pagination>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import Query from "components/query.vue";
export default {
  data() {
    return {
        userType: '',
        size: 20,
        page: 1,
        total: 0,
        allManufacturer: [],

        formData: {
          name: '',
          status: '',
        },
        formList: [
            {
              type: "select",
              label: "桩群名称",
              placeholder: "请选择电站",
              model: "name",
              labelName: 'name',
              valueName: 'name',
              optionList: []
            },
            {
              type: "select",
              label: "状态",
              placeholder: "全部",
              model: "status",
              labelName: 'label',
              valueName: 'id',
              optionList: [
                  {
                    id: 0,
                    label: '申请中'
                  },
                  {
                    id: 1,
                    label: '服务中'
                  },
                  {
                    id: 2,
                    label: '已停用'
                  }
              ]
            },
        ],

        tableData: [],
        stationTotal: 0,
    };
  },
  components: {
    Query,
  },
  created() {
    this.init();
  },
  methods: {
    // 初始化
    init(){
      this.getTableList();
      this.getAllStationGroup();
    },
    // 获取table列表
    getTableList(data){
        let params = {};
        if(data){
            params = data;
        }
        params.page = this.page;
        params.size = this.size;
        this.$http.get(this.common.company + '/company/pileGroupList',{
            params: params
        }).then(res => {
            if(res.code === 200){
                this.tableData = res.data.list;
                this.total = res.data.total;
                this.stationTotal = res.data.pile_count;
            }else{
                this.$message.error(res.msg);
            }
        });
    },
    // 获取所有桩群
    getAllStationGroup(){
        this.$http.get(this.common.company + '/company/pileGroupAllList').then(res => {
            if(res.code === 200){
                for(let i of this.formList){
                    if(i.label === '桩群名称'){
                        i.optionList = res.data;
                    }
                }
            }else{
                return this.$message.error(res.msg);
            }
        });
    },
    // 查询
    query(data) {
      this.page = 1;
      this.getTableList(data);
    },
    // 重置查询--厂商端
    resetQuery(){
      this.page = 1;
      this.formData = {
        name: '',
        status: '',
      };
      this.getTableList();
    },
    // 翻页
    changePage(page){
      this.page = page;
      this.getTableList(this.formData);
    },
    sizeChange(val){
      this.size = val;
      this.getTableList(this.formData);
    },
    // 拼接地址
    stationAddress(data){
      if(data.address.indexOf(data.province_name) != -1){
        return data.address;
      }else{
        return data.province_name + data.city_name + data.area_name + data.address;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.stationGroup{
  height: 100%;
  display: flex;
  flex-direction: column;
  .tableArea{
    flex: 1;
    min-height: calc(100% - 152px);
  }
  .pageFoot{
    .statistical{
      font-size: 14px;
    }
  }
}
</style>